module.exports = __webpack_public_path__ + "img/refer1.png";